import { Box } from "@chakra-ui/react";
import { ColorIcon, customEvent, Spacing } from "goi_common";
import { baseColors, BaseStack } from "goi_common/src/design-system";
import {
  SANGJO_LANDING_EVENT_PATH,
  TRUST_REVIEWS,
  TRUST_STATS,
  TRUST_STATS_BASIS,
} from "./sangjoLandingData";
import { Eyebrow, LandingSection, SectionTitle } from "./SangjoLandingUI";

export default function SangjoLandingTrust() {
  return (
    <LandingSection bg={baseColors.background_accent_1}>
      <Eyebrow>먼저 경험한 가족들</Eyebrow>
      <Spacing gap={8} />
      <SectionTitle>
        고이와 함께한 가족이
        <br />
        남긴 이야기예요
      </SectionTitle>

      <Spacing gap={32} />
      <Box
        display="grid"
        gridTemplateColumns="repeat(3, 1fr)"
        py="20px"
        bg={baseColors.background_normal}
        borderRadius="12px"
        border={`1px solid ${baseColors.line_normal}`}
      >
        {TRUST_STATS.map((stat, i) => (
          <Box
            key={stat.label}
            textAlign="center"
            boxShadow={i === 0 ? "none" : `inset 1px 0 0 ${baseColors.line_normal}`}
          >
            <Box
              className="headline_1_sb"
              color={stat.isAccent ? baseColors.primary_orange : baseColors.label_normal}
            >
              {stat.value}
            </Box>
            <Box className="label_2_r" color={baseColors.label_assistive_1}>
              {stat.label}
            </Box>
          </Box>
        ))}
      </Box>
      <Spacing gap={8} />
      <Box className="caption_2_r" color={baseColors.label_muted_2} textAlign="right">
        {TRUST_STATS_BASIS}
      </Box>

      <Spacing gap={24} />
      <BaseStack spacing={12}>
        {TRUST_REVIEWS.map((review, i) => (
          <Box
            key={review.id}
            p="20px"
            bg={baseColors.background_normal}
            borderRadius="12px"
            border={`1px solid ${baseColors.line_normal}`}
          >
            <Box className="body_2_reading_r" color={baseColors.label_alternative_1}>
              {review.text}
            </Box>
            <BaseStack
              direction="horizontal"
              justifyContent="space-between"
              alignItems="center"
              pt="16px"
            >
              <Box className="caption_1_r" color={baseColors.label_assistive_1}>
                {review.author} · {review.date}
              </Box>
              {/* 후기 상세는 ssr-platform 페이지라 NextLink 대신 전체 이동 */}
              <a
                href={`/review/${review.id}/`}
                onClick={() =>
                  customEvent({
                    newGtm: {
                      path: SANGJO_LANDING_EVENT_PATH,
                      trigger_and_target: `review_link_${i + 1}`,
                    },
                  })
                }
              >
                <BaseStack direction="horizontal" alignItems="center" spacing={2} cursor="pointer">
                  <Box className="label_2_m" color={baseColors.label_alternative_1}>
                    고객 후기 원문 보기
                  </Box>
                  <ColorIcon
                    name="icon_normal_chevron_right"
                    size={16}
                    color={baseColors.label_alternative_1}
                  />
                </BaseStack>
              </a>
            </BaseStack>
          </Box>
        ))}
      </BaseStack>
    </LandingSection>
  );
}
